/**
 * Created by amirb on 8/3/15.
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var NumericInputViewController = require('web-agent-viewControllers/NumericInputViewController');
    var ButtonDropdownViewController = require('web-agent-components/ButtonDropdownViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var SlaChangerFooterViewController = ViewController.extend({
        ControllerName: 'SlaChangerFooterViewController',

        LPViewMap: {
            customInputContainer: '.sla_changer_custom_input',
            customDropDown: '.sla_changer_custom_dropdown',
            customSlaButton: '.sla_submit_button',
            customInput: '.lpview_numeric_input'
        },
        initialize: function (constructorData) {
            this.closeDropUp = constructorData.closeDropUp;
            this.updateChatId(constructorData.chatId);
            this.slaChangerSubmit = constructorData.slaChangerSubmit;
            var footerTemplate = require('web-agent-templates/LP_sla_changer_footer.html');
            // var footerTemplate = lpUtils.loadResource('web-agent-templates/LP_sla_changer_footer.html');
            this.createView({template: footerTemplate});
            this.miliSecForCurrentTimeUint = 60000;
            this.inputBoxViewControler = new NumericInputViewController({
                minimumInputValue: 1,
                maximumInputValue: 9999,
                context: this,
                lostFocusCallback: constructorData.lostFocusCallback
            });
            this.addViewController({viewController: this.inputBoxViewControler, target: this.LPViewMap.customInputContainer});
            this.clearInputBox();
            this.buttonDropdownVC = new ButtonDropdownViewController({
                items: [
                    {title: this.translate('MANUAL_SLA_minutes'), value: 60000},
                    {title: this.translate("MANUAL_SLA_hours"), value: 3600000},
                    {title: this.translate("MANUAL_SLA_days"), value: 86400000}
                ],
                selectedIndex: 0,
                context: this,
                itemClicked: this.rowClicked,
                textProperty: "title",
                lostFocusCallback: constructorData.lostFocusCallback
            });
            this.addViewController({viewController: this.buttonDropdownVC, target: this.LPViewMap.customDropDown});
        },

        events: function () {
            this.bindViewEvent({selector : this.LPViewMap.customSlaButton, DOMEvent : "click", callback : this.customSlaSubmitButtonClicked});
            this.bindViewEvent({selector : this.LPViewMap.customInput, DOMEvent : 'keyup', callback : this.handleKeyUp});
        },

        render: function () {

        }
    });

    SlaChangerFooterViewController.prototype.updateChatId = function (chatId) {
        if (chatId) {
            this.chatId = chatId;
        }
    };

    SlaChangerFooterViewController.prototype.rowClicked = function (data) {
        if (data && data.rowData && data.rowData.value) {
            this.miliSecForCurrentTimeUint = data.rowData.value;
        }
    };

    SlaChangerFooterViewController.prototype.customSlaSubmitButtonClicked = function () {
        if (this.slaChangerSubmit) {
            this.slaChangerSubmit();
        }
        if (!this.isButtonDisabled) {
            var inputBoxValue = this.returnInputValue();
            if (inputBoxValue === '') {
                return;
            }
            this.closeDropUp();
            var miliSec = this.miliSecForCurrentTimeUint * inputBoxValue;
            this.modelController.setManualSla(this.chatId, miliSec);
        }
    };

    SlaChangerFooterViewController.prototype.returnInputValue = function () {
        var inputBox = this.getFirstElement(this.LPViewMap.customInput);
        if (inputBox) {
            return inputBox.value;
        }
    };

    SlaChangerFooterViewController.prototype.handleKeyUp = function (e) {
        var enterClicked = this.getKeyCode(e) === 13;
        this.setDisabled(enterClicked);
    };

    SlaChangerFooterViewController.prototype.getKeyCode = function (e) {
        return e.keyCode || e.which;
    };

    SlaChangerFooterViewController.prototype.clearInputBox = function () {
        var inputBox = this.getFirstElement(this.LPViewMap.customInput);
        if (inputBox) {
            inputBox.value = '';
            this.setDisabled();
        }
        if (this.buttonDropdownVC) {
            this.buttonDropdownVC.collapseItems();
        }

        this.inputBoxViewControler.setCurrentValue('');
    };

    SlaChangerFooterViewController.prototype.setDisabled = function (enterClicked) {
        var buttonView = this.getFirstElement(this.LPViewMap.customSlaButton);
        if (buttonView) {
            if (this.returnInputValue() === '') {
                this.isButtonDisabled = true;
                this.addClass(buttonView, 'disabled');
            } else {
                this.isButtonDisabled = false;
                if (enterClicked) {
                    this.customSlaSubmitButtonClicked();
                }
                this.removeClass(buttonView, 'disabled');
            }
        }
    };

    return SlaChangerFooterViewController;

});
